const formEl = document.querySelector('#warranty-claim-form');
const firstNameEl = document.querySelector('#first-name');
const lastNameEl = document.querySelector('#last-name');
const streetAddressEl = document.querySelector('#street-address');
const addressLine2El = document.querySelector('#address-line-2');
const cityEl = document.querySelector('#city');
const stateEl = document.querySelector('#state');
const zipEl = document.querySelector('#zip');
const countryEl = document.querySelector('#country');
const emailEl = document.querySelector('#email');
const phoneNumberEl = document.querySelector('#phone-number');
const productEl = document.querySelector('#product');
const colorEl = document.querySelector('#color');
const serialNumberEl = document.querySelector('#serial-number');
const dateOfPurchaseEl = document.querySelector('#date-of-purchase');
const descriptionEl = document.querySelector('#description');
const mediaEl = document.querySelector('#media');
const mediaPhotoViewsEl = document.querySelector('#media_photo_views');
const isRepairClaimEl = document.querySelector('#is-repair-claim');
const submitButtonEl = document.querySelector('#submit-warranty-claims-form-button');
const successMessageEl = document.querySelector('#success-message');

async function handleFormSubmit(event) {
  event.preventDefault();
  submitButtonEl.disabled = true;

  const first_name = firstNameEl.value.trim();
  const last_name = lastNameEl.value.trim();
  const street_address = streetAddressEl.value.trim();
  const address_line_2 = addressLine2El.value.trim();
  const city = cityEl.value.trim();
  const state = stateEl.value.trim();
  const zip = zipEl.value.trim();
  const country = countryEl.value.trim();
  const email = emailEl.value.trim();
  const phone_number = phoneNumberEl.value.trim();
  const product = productEl.value.trim();
  const color = colorEl.value.trim();
  const serial_number = serialNumberEl.value.trim();
  const date_of_purchase = dateOfPurchaseEl.value.trim();
  const description = descriptionEl.value.trim();
  const media = mediaEl.files[0];
  const media_photo_views = mediaPhotoViewsEl.files;
  const is_repair_claim = isRepairClaimEl.value === 'true';

  if (media) {
    const maxSize = 25 * 1024 * 1024; // 25MB
    if (media.size > maxSize) {
      alert('The file size is too large. Please upload a file that is less than 25MB.');
      mediaEl.value = null;
      submitButtonEl.disabled = false;
      return;
    }
  }

  Array.from(media_photo_views).forEach(view => {
    const maxSize = 25 * 1024 * 1024; // 25MB
    if (view.size > maxSize) {
      alert('One of the condition photos is too large. Please upload a file that is less than 25MB.');
      submitButtonEl.disabled = false;
      return;
    }
  });

  if (
    first_name &&
    last_name &&
    street_address &&
    city &&
    state &&
    zip &&
    country &&
    email &&
    phone_number &&
    product &&
    serial_number &&
    date_of_purchase &&
    description &&
    media_photo_views.length > 0
  ) {
    const formData = new FormData();
    formData.append('first_name', first_name);
    formData.append('last_name', last_name);
    formData.append('street_address', street_address);
    formData.append('address_line_2', address_line_2);
    formData.append('city', city);
    formData.append('state', state);
    formData.append('zip', zip);
    formData.append('country', country);
    formData.append('email', email);
    formData.append('phone_number', phone_number);
    formData.append('product', product);
    formData.append('color', color);
    formData.append('serial_number', serial_number);
    formData.append('date_of_purchase', date_of_purchase);
    formData.append('description', description);
    formData.append('media', media);
    formData.append('is_repair_claim', is_repair_claim);

    for (let i = 0; i < media_photo_views.length; i++) {
      formData.append(`media_photo_view_${i + 1}`, media_photo_views[i]);
    }

    for (const [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    } // For debugging purposes, you can see the FormData content in the console

    const originUrl = window.location.origin;
    const apiUrl = originUrl === 'https://kiarasky.com' ? 'https://sleepy-ridge-54731-86f3fc602d40.herokuapp.com' : 'http://localhost:8080';

    const response = await fetch(`${apiUrl}/api/warranty/claims`, {
      method: 'POST',
      body: formData,
    });

    if (response.ok) {
      formEl.classList.add('d-none');
      successMessageEl.classList.remove('d-none');
      window.location.assign('/pages/repair-claim-submitted');
    } else {
      alert('An error occurred while registering your claim. Please try again later.');
    }
  }
}

function handleProductChange(event) {
  const value = event.target.value;
  const productsWithColor = [
    'Rechargeable LED Lamp',
    'Rechargeable LED 3',
    'Portable Nail Drill',
    'Nail Dust Collector',
    'Beyond Home LED Lamp',
  ];

  if (productsWithColor.includes(value)) {
    colorEl.parentElement.classList.remove('d-none');
    colorEl.required = true;
  } else {
    colorEl.parentElement.classList.add('d-none');
    colorEl.required = false;
  }
}

productEl.addEventListener('change', handleProductChange);
formEl.addEventListener('submit', handleFormSubmit);
